export default "__VITE_ASSET__dGx1ij3H__"